import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import TechnologyServices from './pages/TechnologyServices';
import SoftwareServices from './pages/SoftwareServices';
import IntelligenceServices from './pages/IntelligenceServices';
import Resources from './pages/Resources';
import ManagedPrograms from './pages/ManagedPrograms';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/services/technology" element={<TechnologyServices />} />
            <Route path="/services/software" element={<SoftwareServices />} />
            <Route path="/services/intelligence" element={<IntelligenceServices />} />
            <Route path="/services/software/managed-programs" element={<ManagedPrograms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
